/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useContext } from "react";
import { StyleSheet, Platform } from "react-native";
import { useTheme } from "../../../../providers/theme";
// import {getStatusBarHeight} from '../../../../react-native-helpers';
import { BackButtonV } from "../../../../widgets/BackButtonV";

interface IBackButtonProps {
  onBackPress?: () => void;
}

export const BackButton = ({ onBackPress }: IBackButtonProps): JSX.Element => {
  const theme = useTheme();
  const styles = StyleSheet.create({
    container: {
      top: "3%",
      // Platform.OS === 'ios'
      //   ? 12
      //   : getStatusBarHeight()
      //   ? getStatusBarHeight() + 10
      //   : 40,
      left: 22,
      backgroundColor: "pink",
    },
  });

  return (
    <BackButtonV
      onIconPress={onBackPress}
      iconContainerStyle={StyleSheet.flatten([styles.container])}
      iconColor={"#05A9EF"}
    />
  );
};



// {theme?.colors?.primary}
